<template>
    <div class="float-left mr-1">
        <span class="text-primary">
            <i
                class="fa fa-pencil-square-o fa-lg icon-button"
                title="Atualizar item"
                @click.stop="abrirModal()"
            ></i>
        </span>
        <b-modal v-model="mostrarModal">
            <div slot="modal-title">
                Atualizar valor/quantidade do item da requisição
            </div>
            <b-row v-if="itemRequisicao">
                <b-col sm="12">
                    <detalhe titulo="Código" :size="size1">{{
                        itemRequisicao.idItemContrato
                    }}</detalhe>
                    <detalhe titulo="Item do Contrato" :size="size1">{{
                        itemRequisicao.descricao
                    }}</detalhe>
                    <detalhe titulo="Valor Unitário" :size="size1">{{
                        itemRequisicao.valorUnitario | currency
                    }}</detalhe>
                    <detalhe titulo="Quantidade" :size="size1">{{
                        itemRequisicao.quantidade
                    }}</detalhe>
                    <detalhe titulo="Sub Total" :size="size1">{{
                        itemRequisicao.subTotal | currency
                    }}</detalhe>
                    <detalhe titulo="Desconto" :size="size1">{{
                        itemRequisicao.desconto | currency
                    }}</detalhe>
                    <detalhe titulo="Valor Total" :size="size1">{{
                        itemRequisicao.valorTotal | currency
                    }}</detalhe>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-row v-if="!apenasQtd">
                        <b-col sm="12">
                            <b-form-group
                                :state="$v.valorUnitario.$error ? false : null"
                                invalid-feedback="O valor é obrigatório"
                            >
                                <label class="required">Valor</label>
                                <money
                                    ref="valorUnitario"
                                    v-model="valorUnitario"
                                    v-bind="money"
                                    class="form-control text-right"
                                    @input.native="$v.valorUnitario.$touch()"
                                ></money>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="12">
                            <b-form-group
                                :state="$v.quantidade.$error ? false : null"
                                invalid-feedback="A quantidade é obrigatória"
                            >
                                <label class="required">Quantidade</label>
                                <money
                                    ref="quantidade"
                                    v-model="quantidade"
                                    v-bind="decimal"
                                    class="form-control text-right"
                                    @input.native="$v.quantidade.$touch()"
                                ></money>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button
                    variant="secondary"
                    @click.stop="fecharModal()"
                    class="mr-2"
                    >Cancelar</b-button
                >
                <b-button
                    variant="primary"
                    :disabled="$v.$invalid || valoresInalterados"
                    @click.stop="confirmarAtualizar()"
                >
                    Atualizar</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
    props: {
        itemRequisicao: {
            type: Object
        }
    },

    data() {
        return {
            valorUnitario: 0,
            quantidade: 0,
            mostrarModal: false,
            erros: [],
            size1: '130',
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            },
            decimal: {
                decimal: ',',
                thousands: '.',
                prefix: '',
                suffix: '',
                precision: 2,
                masked: false
            }
        }
    },

    validations: {
        quantidade: {
            required,
            qtdOk() {
                return this.quantidade > 0
            }
        },
        valorUnitario: {
            valorOk() {
                if (this.itemRequisicao.isSubItem) {
                    return true
                }
                return this.valorUnitario > 0
            }
        }
    },

    methods: {
        fecharModal() {
            this.valorUnitario = 0
            this.quantidade = 0
            this.$nextTick(() => {
                this.$v.$reset()
            })
            this.mostrarModal = false
        },

        abrirModal() {
            this.mostrarModal = true
            this.valorUnitario = this.itemRequisicao.valorUnitario
            this.quantidade = this.itemRequisicao.quantidade
        },

        confirmarAtualizar() {
            this.$swal({
                title: 'Atualização de item da requisição',
                html: `Confirma a atualizado do item ${this.itemRequisicao.descricao} da requisição?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.atualizarItem()
                }
            })
        },

        atualizarItem() {
            let itemDto = {
                idItemRequisicao: this.itemRequisicao.idItemRequisicao,
                valorUnitario: this.itemRequisicao.isSubItem
                    ? this.itemRequisicao.valorUnitario
                    : this.valorUnitario,
                quantidade: this.quantidade
            }
            this.$emit('atualizarItem', itemDto)
            this.fecharModal()
        }
    },

    computed: {
        apenasQtd() {
            return this.itemRequisicao.isSubItem
        },

        valoresInalterados() {
            return (
                this.valorUnitario == this.itemRequisicao.valorUnitario &&
                this.quantidade == this.itemRequisicao.quantidade
            )
        }
    }
}
</script>
